import { Button, Flex } from 'antd'
import Input from 'components/Input'
import { InputFieldTypes } from 'components/Input/types'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import React, { useContext } from 'react'
import { OnGetHouseHoldCallback } from '../../../NpvrComponent'
import './index.scss'

type SearchProps = {
  hhid: string
  setHhid: React.Dispatch<React.SetStateAction<string>>
  onGetHouseHold: OnGetHouseHoldCallback
}

function handleOnEnter(event: React.KeyboardEvent<HTMLInputElement>, hhid: string, onGetHouseHold: OnGetHouseHoldCallback) {
  if (['Enter', 'NumpadEnter'].includes(event.key) && (hhid && hhid !== '*')) {
    onGetHouseHold(hhid)
  }
}

export default function SearchComponent({ hhid, setHhid, onGetHouseHold }: SearchProps) {
  const t = useContext(I18nContext)

  return (
    <Flex>
      <div className="npvr-header-input-wrap">
        <Input
          type={InputFieldTypes.text}
          value={hhid}
          setValue={value => setHhid(value)}
          onKeyDown={(event) => handleOnEnter(event, hhid, onGetHouseHold)}
          labelParams={{ 
            i18nTag: 'HHID'
           }}
        />
      </div>
      <Button
        type='primary'
        className='hhid-search-button'
        disabled={!hhid || hhid === '*'}
        onClick={() => onGetHouseHold(hhid)}
      >
        {t('general.search')}
      </Button>
    </Flex>
  )
}
